import { action, computed, makeAutoObservable, observable } from "mobx";
import { Gtm } from "../utils/Gtm";
import { Clarity } from "../utils/Clarity";

export default class FiltersStore {
    @observable filters:Map;
    constructor({store}) {
        this.filters = new Map();
        makeAutoObservable(this);

    }

    getFilter(name) {
        if(!this.filters.has(name)) {
            throw new Error(`Filter ${name} not found`);
        }
        return this.filters.get(name);
    }
    getFilters() {
        return Array.from(this.filters.values());
    }

    getOptions(name) {
        return this.getFilter(name).options || [];
    }
    getSelectedOptionByName(name, value) {
        var options = this.getOptions(name);
        return options.find(option => option.value === value);
    }
    getFilterValue(name) {
        return this.getFilter(name).value;
    }


    getSelectedOptions(name) {
        const values = this.getFilterValue(name) || [];
        const options = this.getOptions(name);
        // filter and sort by values order
        return options.filter(option => values.includes(option.value)).sort((a, b) => values.indexOf(a.value) - values.indexOf(b.value));
    }



    @action addFilter(name, {value = '', type, options = [], multiple = false, defaultValue = ''}) {
        
        this.filters.set(name, {value, type, options, defaultValue});
    }

    @action setOptions(name, options) {
        var filter = this.getFilter(name);
        if(!filter) {
            throw new Error(`Filter ${name} not found`);
        }
        filter.options = options;
    }
 

    @action setFilterValue(name, value) {
        var filter = this.getFilter(name);
        if(!filter) {
            throw new Error(`Filter ${name} not found`);
        }
        var _value = this.getFilterValue(name);
        if(Array.isArray(_value)) {
            _value = [..._value];
            if(_value.includes(value)) {
                _value = _value.filter(v => v !== value);
            } else {
                _value.push(value);
            }
            this.filters.get(name).value = _value;
        }else{
            this.filters.get(name).value = value;
            
        }

        this.onFilterChange(name, value);

    }

    onFilterChange(name, value) {
        var option = this.getSelectedOptionByName(name, value);
        console.log('onFilterChange', {name, value, option});
        if(option) {
            const valueName = String(option.label ?? option.name).toLowerCase();

            Gtm.push({
                  event: "konfigurator_click",
                ecommerce: {
                    button_name: `${name} - ${valueName}`,
                    value: Gtm.getPrice(),
                    items: [
                        {
                        item_name: Gtm.getProductName(),
                        item_id: Gtm.getProductId(),
                        item_brand: "MyBed",
                        item_category: "Łóżka",
                        item_variant: Gtm.getVariantStr(),
                        }
                    ]
                }
            })
            Clarity.push(`konfigurator_click - ${name} - ${valueName}`);
        }
        return null;
    }

    getValues() {
        var obj = {};

        this.filters.forEach((filter, key) => {
            obj[key] = filter.value;
        });
        return obj;
    } 

    _areSameByValue(a, b) {
        console.log({
            a: JSON.stringify(a),
            b: JSON.stringify(b)
        });
        return JSON.stringify(a) === JSON.stringify(b);
    }

    /**
     * When filters are diffrent from thiers defaults
     */
    @computed get hasFilters() {
        if(!this.filters) {
            return false;
        }
        return this.getFilters().some(filter => this._areSameByValue(filter.value, filter.defaultValue) === false);
    } 

    @action resetFilters() {
        this.getFilters().forEach((filter) => {
            filter.value = filter.defaultValue;
        });
    }
}